import { yupDateRangeValidation } from '@product-framework/components/FormFields';
import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      brandId: yup
        .string()
        .nullable()
        .test(
          'brandId-min-length',
          formatMessage({
            id: 'BRANDID_MIN_LENGTH',
            defaultMessage: 'Brand ID must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      serviceJobNumber: yup
        .string()
        .nullable()
        .test(
          'serviceJobNumber-min-length',
          formatMessage({
            id: 'SERVICEJOBNUMBER_MIN_LENGTH',
            defaultMessage: 'Job Number must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      customerName: yup
        .string()
        .nullable()
        .test(
          'customerName-min-length',
          formatMessage({
            id: 'CUSTOMERNAME_MIN_LENGTH',
            defaultMessage: 'Customer Name must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      customerAddressCity: yup
        .string()
        .nullable()
        .test(
          'customerAddressCity-min-length',
          formatMessage({
            id: 'CUSTOMERADDRESSCITY_MIN_LENGTH',
            defaultMessage: 'City must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      customerAddressState: yup.object().nullable(),
      brand: yup.object().nullable(),
      productType: yup.object().nullable(),
      customerAddressPostalCode: yup
        .string()
        .nullable()
        .test(
          'customerAddressPostalCode-min-length',
          formatMessage({
            id: 'CUSTOMERADDRESSPOSTALCODE_MIN_LENGTH',
            defaultMessage: 'Postal Code must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      productTypeId: yup
        .string()
        .nullable()
        .test(
          'productTypeId-min-length',
          formatMessage({
            id: 'PRODUCTTYPEID_MIN_LENGTH',
            defaultMessage: 'Product ID must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      customerComplaint: yup
        .string()
        .nullable()
        .test(
          'customerComplaint-min-length',
          formatMessage({
            id: 'CUSTOMERCOMPLAINT_MIN_LENGTH',
            defaultMessage: 'Customer Complaint must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      appointmentDate: yupDateRangeValidation({
        testName: 'appointmentDate-value=required-on-operator',
        sameErrMessage: 'Appointment Dates cannot be same for between',
        greaterThnErrMessage:
          'Appointment Date start needs to be greater than end date',
        validBetweenDateMessage:
          'Appointment Date must have 2 valid dates for between',
        requiredMessage: 'Appointment Date is required',
        validDateMessage: 'Appointment Date should be valid date',
      }),
      serviceJobStatusDate: yupDateRangeValidation({
        testName: 'serviceJobStatusDate-value=required-on-operator',
        sameErrMessage: 'Job Status dates cannot be same for between',
        greaterThnErrMessage:
          'Job Status date start needs to be greater than end date',
        validBetweenDateMessage:
          'Job Status date must have 2 valid dates for between',
        requiredMessage: 'Job Status date is required',
        validDateMessage: 'Job Status date should be valid date',
      }),
      dispatchJobStatusDate: yupDateRangeValidation({
        testName: 'dispatchJobStatusDate-value=required-on-operator',
        sameErrMessage: 'Dispatch Status dates cannot be same for between',
        greaterThnErrMessage:
          'Dispatch Status date start needs to be greater than end date',
        validBetweenDateMessage:
          'Dispatch Status date must have 2 valid dates for between',
        requiredMessage: 'Dispatch Status date is required',
        validDateMessage: 'Dispatch Status date should be valid date',
      }),
      customerServiceRequests: yupDateRangeValidation({
        testName: 'customerServiceRequests-value=required-on-operator',
        sameErrMessage: 'Service Request dates cannot be same for between',
        greaterThnErrMessage:
          'Service Requested date start needs to be greater than end date',
        validBetweenDateMessage:
          'Service Requested date must have 2 valid dates for between',
        requiredMessage: 'Service Requested date is required',
        validDateMessage: 'Service Requested date should be valid date',
      }),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'ATLEASTONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );
export default validationSchema;
